var _rect, _text, _rect2, _circle, _text2, _rect3, _circle2, _text3, _rect4, _circle3, _text4, _rect5, _circle4, _text5, _path, _circle5, _path2, _text6, _path3, _text7, _rect6, _circle6, _text8, _path4, _circle7, _circle8, _rect7, _text9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomDevelopmentProcessTransformationBeforeAfterMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 360,
    height: 650,
    viewBox: "0 0 360 650",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Process transformation before and after") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 358,
    height: 648,
    rx: 27,
    fill: "#EEF5FC",
    stroke: "#BED7EE"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 38,
    fill: "#FF2775",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 850,
    letterSpacing: 1.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 24,
    dy: 0
  }, "BEFORE"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 62,
    width: 145,
    height: 48,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#087CFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 86,
    r: 5,
    fill: "#087CFF"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 91,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 780
  }, "INBOX")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 62,
    width: 145,
    height: 48,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#30D6A1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 86,
    r: 5,
    fill: "#30D6A1"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 223,
    y: 91,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 780
  }, "SPREADSHEET")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 124,
    width: 145,
    height: 48,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#FF2775"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 148,
    r: 5,
    fill: "#FF2775"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 153,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 780
  }, "CHAT THREAD")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 124,
    width: 145,
    height: 48,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#F4B63D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 148,
    r: 5,
    fill: "#F4B63D"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 223,
    y: 153,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 780
  }, "LEGACY TOOL")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 174 180 224M264 174 180 224",
    stroke: "#8DA8C2",
    strokeWidth: 2,
    strokeDasharray: "4 6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 226,
    r: 36,
    fill: "#07152A",
    stroke: "#FF2775",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m166 212 28 28m0-28-28 28",
    stroke: "#FFFFFF",
    strokeWidth: 2
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 281,
    textAnchor: "middle",
    fill: "#536985",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 800,
    letterSpacing: 0.8
  }, "DELAY \xB7 DUPLICATION \xB7 BLIND SPOTS")), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M180 303v45m-6-7 6 7 6-7",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 383,
    fill: "#087CFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 850,
    letterSpacing: 1.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 24,
    dy: 0
  }, "AFTER"))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 405,
    width: 312,
    height: 128,
    rx: 20,
    fill: "#07152A"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 469,
    r: 43,
    fill: "#0B2340",
    stroke: "#087CFF",
    strokeWidth: 2
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 458,
    fill: "#FFFFFF",
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14,
    fontWeight: 850,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 180,
    dy: 0
  }, "ONE MANAGED"), /*#__PURE__*/React.createElement("tspan", {
    x: 180,
    dy: 18
  }, "WORKFLOW"))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77 469h56M227 469h56",
    stroke: "#4A9BE4",
    strokeWidth: 2,
    strokeDasharray: "4 6"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 469,
    r: 7,
    fill: "#30D6A1"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 297,
    cy: 469,
    r: 7,
    fill: "#F4B63D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 555,
    width: 312,
    height: 65,
    rx: 15,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 43,
    y: 581,
    fill: "#07152A",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 800,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 43,
    dy: 0
  }, "CLEAR OWNERSHIP \xB7 LIVE STATUS"), /*#__PURE__*/React.createElement("tspan", {
    x: 43,
    dy: 17
  }, "EVIDENCE AT EVERY DECISION"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDevelopmentProcessTransformationBeforeAfterMobile);
export default __webpack_public_path__ + "static/media/custom-development-process-transformation-before-after-mobile.3682f81220b52a0959df17660452b4a2.svg";
export { ForwardRef as ReactComponent };